module.exports = __webpack_public_path__ + "static/wood-cutting-hands-36e29bc1c21b4b90cd96f7e80429aa05.jpg";